import Link from "next/link";
import {Color, getCssVar} from "@web-libs/features/colors/application/colors";
import {CSSProperties} from "react";

export const StyledLink = ({href, text, color}: {href:string, text:string, color?:Color}) => {

    const _color:Color = color ? color : "dark"

    return <Link style={{
        color: getCssVar(_color),
        fontSize: 18,
        textDecoration: "underline",
    }} href={href}>{text}</Link>
}

export const StyledLinkButton = ({onClick, text, color, disabled, style}: {onClick:()=>void, text:string, color?:Color, style?:CSSProperties, disabled?:boolean}) => {

    const _color:Color = color ? color : "dark"

    return <button style={{
        color: getCssVar(_color),
        fontSize: 18,
        textDecoration: "underline",
        border: "none",
        backgroundColor: "transparent",
        cursor: "pointer",
        opacity: disabled ? 0.7 : 1,
            ...style
    }} onClick={disabled ? ()=>{} :onClick}>{text}</button>
}
